import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';

export type CampaignDistributionMode = 'public' | 'invite_only';

interface CampaignDistributionModeFieldsProps {
  value: CampaignDistributionMode;
  onChange: (mode: CampaignDistributionMode) => void;
  name?: string;
  disabled?: boolean;
}

/** Open-to-all vs invite-only distribution choice. */
export const CampaignDistributionModeFields: React.FC<CampaignDistributionModeFieldsProps> = ({
  value,
  onChange,
  name = 'campaign-distribution-mode',
  disabled = false,
}) => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:gap-6">
      <label className="flex items-center gap-2 text-sm text-[var(--color-surface-text)]">
        <input
          type="radio"
          name={name}
          className="accent-[var(--color-accent-bg)]"
          checked={value === 'public'}
          disabled={disabled}
          onChange={() => onChange('public')}
        />
        <span>{t('assessmentEngine.distribution.public')}</span>
      </label>
      <label className="flex items-center gap-2 text-sm text-[var(--color-surface-text)]">
        <input
          type="radio"
          name={name}
          className="accent-[var(--color-accent-bg)]"
          checked={value === 'invite_only'}
          disabled={disabled}
          onChange={() => onChange('invite_only')}
        />
        <span>{t('assessmentEngine.distribution.invite_only')}</span>
      </label>
    </div>
  );
};
